module.exports = __webpack_public_path__ + "img/media_11.e63f81c9.jpg";